import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import customRoutesSrc from './images/custom-routes-thumb.avif';

// https://www.figma.com/design/vV97hwFyKhekbcMy2TuNyz/Feature-Merchandising?node-id=840-95326&t=XlR2wnwWYYfdIIZ3-4
const customRoutes = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Custom Routes' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Start from scratch or customize to create your perfect adventure in the app' }),
  thumbnailImage: customRoutesSrc.src
});

export default customRoutes;
